import { Router } from "../../../server/router"
import type { EpicDependencies } from "../../rxjs/configureEpics"
import { CLOSE_LOCATION_FORM_CLICKED, DELETE_LOCATION_CLICKED, LOCATION_FORM_SUBMITTED } from "./actions"
import { getCurrentPathName } from "../../router/selectors"

import { Action, StateObject } from "../../redux/types"
import { ofType, StateObservable } from "redux-observable"
import { EMPTY, Observable } from "rxjs"
import { switchMap } from "rxjs/operators"

export const locationsSubmittedRouterEpics = (
    actions$: Observable<Action>,
    state$: StateObservable<StateObject>,
    deps: EpicDependencies
) =>
    actions$.pipe(
        ofType(LOCATION_FORM_SUBMITTED, CLOSE_LOCATION_FORM_CLICKED, DELETE_LOCATION_CLICKED),
        switchMap(() => {
            const pathName = getCurrentPathName(deps.getState())

            if (pathName === "/app/makeItButterSettings") {
                Router.push("/make-it-butter-settings")
            } else {
                Router.push("/locations")
            }

            return EMPTY
        })
    )

export default [locationsSubmittedRouterEpics]
